import userConfigurationNameType from 'owa-service/lib/factory/userConfigurationNameType';
import UserConfigurationNameType from 'owa-service/lib/contract/UserConfigurationNameType';
import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';

export default function getMailboxExportUserConfigurationName(): UserConfigurationNameType {
    return userConfigurationNameType({
        Name: 'MailExportRequest',
        BaseFolderId: distinguishedFolderId({ Id: 'root' }),
    });
}
